<template>
  <div class="row">
    <div class="col-md-12">
      <div class="content">
        <div class="row">
          <div class="card mb-3 mx-3">
            <img
              src="@/assets/banner-pajak.jpg"
              id="bannerPajak"
              alt=""
              class="rounded-sm"
            />
          </div>
          <div class="col-xl-4">
            <StatisticProfile></StatisticProfile>
            <NilaiTransaksi></NilaiTransaksi>
            <ProdukPopuler></ProdukPopuler>
          </div>
          <div class="col-xl-8">
            <WraperRightDashboard></WraperRightDashboard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//attribute
import StatisticProfile from "../components/seller/DashboardAttr/StatisticProfile";
import NilaiTransaksi from "../components/seller/DashboardAttr/NilaiTransaksi";
import ProdukPopuler from "../components/seller/DashboardAttr/ProdukPopuler";
import WraperRightDashboard from "../components/seller/DashboardAttr/WraperRightDashboard";

// import $ from "jquery";
// import axios from 'axios'

export default {
  components: {
    StatisticProfile,
    NilaiTransaksi,
    ProdukPopuler,
    WraperRightDashboard,
  },
  // mounted: function () {
  //   $("#table_order").DataTable({
  //     // "order": [[ 7, "desc" ]],
  //     dom: "rtip", // the "r" is for the "processing" message
  //     language: {
  //       processing: `<div class="loadingio-spinner-spinner-os5gb82q6fi"><div class="ldio-9n8m4se50l">
  //       <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
  //       </div></div>`,
  //       info: "Showing page _PAGE_ of _PAGES_",
  //     },
  //     processing: true,
  //     // serverSide: true,
  //     ajax: {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //       url: `${axios.defaults.baseURL}orders?dataTable`,
  //     },
  //     columns: [
  //       {
  //         data: "orderId",
  //         name: "orderId",
  //         render: function (data, type, row, meta) {
  //           return meta.row + meta.settings._iDisplayStart + 1;
  //         },
  //       },
  //       {
  //         data: "invoice",
  //         name: "invoice",
  //         render: function (data) {
  //           return `<div class="font-weight-bold text-left" style="color:#495057">${data}</div>`;
  //         },
  //       },
  //       {
  //         data: "npsn",
  //         name: "npsn",
  //       },
  //       {
  //         data: "shippingCompany",
  //         name: "shippingCompany",
  //       },
  //       {
  //         data: "shippingCity",
  //         name: "shippingCity",
  //       },
  //       {
  //         data: "statusName",
  //         name: "statusName",
  //         render: function (data) {
  //           if (data == "Dibatalkan") {
  //             return '<span class="badge badge-danger">' + data + "</span>";
  //           } else if (data == "Diterima") {
  //             return '<span class="badge badge-success">' + data + "</span>";
  //           } else if (data == "Ditolak Penyedia") {
  //             return '<span class="badge badge-danger">' + data + "</span>";
  //           } else if (data == "Diproses") {
  //             return '<span class="badge badge-warning">' + data + "</span>";
  //           } else {
  //             return '<span class="badge badge-success">' + data + "</span>";
  //           }
  //         },
  //       },
  //       {
  //         data: "orderTotal",
  //         name: "orderTotal",
  //         render: $.fn.dataTable.render.number(".", ",", 0, "Rp. "),
  //       },
  //       {
  //         data: "orderDate",
  //         name: "orderDate",
  //       },
  //       {
  //         data: "orderTempo",
  //         name: "orderTempo",
  //         render: function (data) {
  //           return data + " hari";
  //         },
  //       },

  //       {
  //         data: "fullName",
  //         name: "fullName",
  //       },
  //       // {
  //       //   data: "action",
  //       //   name: "action",
  //       // },
  //     ],
  //   });
  // },
};
</script>

<style>
.btn:not([data-action]):not([class*="btn-outline-"]):hover,
.navbar
  .navbar-nav
  > a.btn:not([data-action]):not([class*="btn-outline-"]):hover {
  box-shadow: none;
}
</style>
